import { createSlice  } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "widgetId",

  initialState: {
    embedId: null,
    productHandle: null,
    shopDomain: null,
    galleryId: null,
    shopId: null,
    photoRequestId: null
  },

  reducers: {
    widgetIdUpdated: (widgetId, action) => {
      const { embedId, productHandle, shopDomain, photoRequestId } = action.payload;
      widgetId.embedId = embedId;
      widgetId.productHandle = productHandle; 
      widgetId.shopDomain = shopDomain;
      widgetId.photoRequestId = photoRequestId;
    },

    widgetGalleryIdUpdated: (widgetId, action) => {
      widgetId.galleryId = action.payload;
    },

    widgetShopIdUpdated: (widgetId, action) => {
      widgetId.shopId = action.payload;
    }
  }
});

export const { widgetIdUpdated, widgetGalleryIdUpdated, widgetShopIdUpdated } = slice.actions;
export default slice.reducer;
